<template>
    <h3>Download Document</h3>
    <div><h4>File ID: <span style="color: red;">{{ capturedFileID }}</span></h4></div>
    <br/>
    <div>
        <a href="D:/Users/david.collins/Dave/Dev/Database/DocComp/DB_Scripts/100_Document_SPs.sql" target="_blank">Get file (file explorer link)</a>
    </div>
    <br/>
    <div>
        <a href="https://www.jccs.gov/caams/docs/CAAMS_Vendor_User_Guide.pdf" target="_blank">#2 Get file (CAMMS PDF)</a>
    </div>
    <br/>
    <div>
        <!-- <RouterLink to="/docCompHosting"><span style="font-size: 24px">Return</span></RouterLink> -->

        <RouterLink to="/docCompHosting" custom v-slot="{ navigate }">
            <button class="btnRounder" @click="navigate" role="link">Return (Router Link Back)</button>
        </RouterLink>

    </div>
    <br/>
    <div>

        <a href='' download='D:/Users/david.collins/Dave/Dev/Database/DocComp/DB_Scripts/100_Document_SPs.sql' >Download (Anchor)</a>
        <p> </p>
        <button @click="downloadFile">Download File (Button)</button>

    </div>
</template>

<script>
// import something from  '../../../../src'

        //DOES NOT WORK
        // let fileURL = 'D:/Users/david.collins/Dave/Dev/Database/DocComp/DB_Scripts/100_Document_SPs.sql';
        // let docName = this.$data.gridTime.grid[i]['fullDocumentName'];
        // this.$data.gridTime.grid[i]['fullDocumentName'] = 
        // "<a href='' download='" + fileURL + "' style='cursor: pointer; color: blue;'>" + docName + "</a>";

export default {

 data() {return{

    capturedFileID: null,

};},

created() {
    console.log('this.$route.query.FileID = ', this.$route.query.FileID);
    this.processFile(this.$route.query.FileID);
  },
  computed: {},
  methods: {
    processFile(fileID) {
        console.log('processFile(): fileID = ', fileID);
        this.$data.capturedFileID = fileID;
    },

    downloadFile() {
        console.log('downloadFile(): ');
        window.open('D:/Users/david.collins/Dave/Dev/Database/DocComp/DB_Scripts/100_Document_SPs.sql');
    },
  },
};
</script>

<style scoped>
.btnRounder {
    font-size: 20px;
    border-radius: 10px;
    color: #e6e6e6;
    background-color: #0033cc;
}
</style>

